import React, { StatelessComponent } from 'react';
import b from 'b_';

import Rect from '@components/rect';

import './breadcrumbs.css';

const class_ = b.with('breadcrumbs-stub');

const BreadcrumbsStub: StatelessComponent = () => {
    return (
        <div className={class_()}>
            <Rect width={50} height={24} />
            <Rect width={50} height={24} />
            <Rect width={250} height={24} />
        </div>
    );
};

export default BreadcrumbsStub;
